import { render, staticRenderFns } from "./OffersCategories.vue?vue&type=template&id=d49f59a0"
import script from "./OffersCategories.vue?vue&type=script&lang=ts"
export * from "./OffersCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports